import React from "react";
import { useState } from "react";
import { BusinessController, WalletController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { ApproveFxTx, InflowReviewModal } from "../../pages";
import { date, object, string } from "yup";
import { walletStore } from "../../stores";

const InflowReviewModalContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return object({
      action: string().required("Please select an action"),
    });
  };

  const inflowData = walletStore.inflowData;

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      Id: inflowData._id,
      action: values.action,
      amount: values.amount
    };

    const { status, errorMessage } =
      await WalletController.reviewInflow(payload);

    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({ message: status });
      return closeModal();
    }

    setLoading(false);
    return MimaToastUtil.error({ message: errorMessage });
  };

  return (
    <InflowReviewModal
      onSubmit={onSubmit}
      closeModal={closeModal}
      loading={loading}
      validationSchema={validationSchema}
      inflowData={inflowData}
    />
  );
};
export default InflowReviewModalContainer;
